import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-my-searches-help-dialog',
  templateUrl: './my-searches-help-dialog.component.html',
  styleUrls: ['./my-searches-help-dialog.component.scss'],
})
export class MySearchesHelpDialogComponent {
}
